module.exports = __webpack_public_path__ + "img/bixiu05.a99fc9fe.png";